import { useQuery } from '@tanstack/react-query';
import { formatNumber } from '@/utils/number';
import { pcmpRequestCountsQueryOptions } from '../../api/pcmpRequests.api';
import {
  PCMP_REQUEST_VIEW_COUNT,
  PCMP_REQUEST_VIEW_LABELS,
} from '../../constants/pcmpRequest.constants';
import { usePcmpRequestFilters } from '../../hooks/usePcmpRequestFilters';
import { PCMP_REQUEST_VIEWS } from '../../types/pcmpRequest.types';
import { PcmpQueueFilterBar } from '../PcmpQueue/PcmpQueueFilterBar';
import { PcmpQueueTabs } from '../PcmpQueue/PcmpQueueTabs';
import { PcmpRequestListView } from './PcmpRequestListView';
import { PcmpRequestMineView } from './PcmpRequestMineView';
import { PcmpUrgentBatchesView } from './PcmpUrgentBatchesView';
import { PcmpUrgentRequestsView } from './PcmpUrgentRequestsView';

/** Legacy RequestQueue: find proposals, raise requests, follow them and the urgent batches. */
export function PcmpRequestQueueTable() {
  const controller = usePcmpRequestFilters();
  const { tab, appliedFilters, queueParams } = controller;

  const { data: counts } = useQuery(pcmpRequestCountsQueryOptions(appliedFilters));

  return (
    <div className="flex flex-col gap-4 lg:h-[calc(100dvh-88px)]">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold">Request Proposals</h1>
        <p className="text-sm text-muted-foreground" aria-live="polite">
          {counts ? `${formatNumber(counts.mine)} of your requests awaiting a decision` : ' '}
        </p>
      </div>

      <PcmpQueueTabs
        tabs={PCMP_REQUEST_VIEWS}
        labels={PCMP_REQUEST_VIEW_LABELS}
        value={tab}
        countOf={counts ? (value) => PCMP_REQUEST_VIEW_COUNT[value](counts) : undefined}
        onChange={controller.setTab}
      />

      <PcmpQueueFilterBar controller={controller} idPrefix="pcmp-request" />

      {tab === 'URGENT_REQUESTS' ? (
        <PcmpUrgentRequestsView controller={controller} />
      ) : queueParams === null ? (
        <PcmpUrgentBatchesView controller={controller} />
      ) : tab === 'MINE' ? (
        <PcmpRequestMineView controller={controller} params={queueParams} />
      ) : (
        <PcmpRequestListView controller={controller} params={queueParams} counts={counts} />
      )}
    </div>
  );
}
